import { Light16, LightFilled16 } from '@carbon/icons-react';
import React from 'react';

export const SpotlightActionIcon = ({
  isActive,
  className,
}: {
  isActive?: boolean;
  className?: string;
}) =>
  isActive ? (
    <LightFilled16 className={className} />
  ) : (
    <Light16 className={className} />
  );
